

export default async (to, from, savedPosition) => {
            if (to.hash && to.path.split('/')[2] == 'qanda') {
                const findEl = async (hash, count) => {
                    return new Promise((resolve, reject) => {
                        let el = document.getElementById(hash.replace('#', ''));
                        if (!!el) return resolve(
                            el.scrollIntoView({
                                behavior: 'smooth',
                                block: hash == '#pageTitle' ? 'nearest' : 'start'
                            })
                        )
                        if (count > 50) return resolve();
                        setTimeout(resolve(findEl(hash, count + 1)), 100);
                    })
                }
                return await findEl(to.hash, 0);
            } else {
                return;
            }
        }
